import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { LocalStorage } from 'ngx-store';

//Model
import { Url } from '../model/users.model';

@Injectable()
export class NotificationsSettingsService {
    @LocalStorage() url: Url;

    constructor(public http: HttpClient) {
    }

    // Http Headers
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json'
    })
    };

	getGlobalNotificationSetting(): Observable<any> {
		return this.http.get<any>(this.url.rest  + '/tms/getGlobalNotificationSettings', this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            );
    }

    getCustomerNotificationSetting(customer_id: number): Observable<any> {
		return this.http.get<any>(this.url.rest  + '/tms/getCustomerNotificationSettings/' + customer_id, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            );
    }

    getBusinessNotificationSettings(): Observable<any> {
		return this.http.get<any>(this.url.rest  + '/tms/getBusinessNotificationSettings', this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            );
    }

    createNotificationGlobalSettings(global_settings): Observable<any> {
		return this.http.post<any>(this.url.rest  + '/tms/createNotificationGlobalSettings', global_settings, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    createNotificationCustomerSettings(customer_settings): Observable<any> {
		return this.http.post<any>(this.url.rest  + '/tms/createNotificationCustomerSettings', customer_settings, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    checkNotificationEnableSettings(notification_id, customer_id): Observable<any> {
		return this.http.get<any>(this.url.rest  + '/tms/checkNotificationEnableSettings/' + notification_id + '/' + customer_id, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    createNotificationBusinessSettings(business_settings): Observable<any> {
		return this.http.post<any>(this.url.rest  + '/tms/createNotificationBusinessSettings', business_settings, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    async isSMSEnabled(notification_id, customer_id){
        
        var is_global_sms_enabled = false;
        var is_customer_sms_enabled = false;
        var is_sms_enabled = false;
        
        is_sms_enabled = await this.checkNotificationEnableSettings(notification_id, customer_id).toPromise().then(result=>{
            let result_boolean = false;
            is_global_sms_enabled = result['is_global_sms_enabled'];
            is_customer_sms_enabled = result['is_customer_sms_enabled'];

            if(is_global_sms_enabled == true && is_customer_sms_enabled == true){result_boolean = true}
            else if(is_global_sms_enabled == true && is_customer_sms_enabled == false){result_boolean = false}
            else if(is_global_sms_enabled == false && is_customer_sms_enabled == true){result_boolean = false}
            else if(is_global_sms_enabled == false && is_customer_sms_enabled == false){result_boolean = false};
            return result_boolean;
        })

        return is_sms_enabled;

    }

    async isEmailEnabled(notification_id, customer_id){

        var is_global_email_enabled = false;
        var is_customer_email_enabled = false;
        var is_email_enabled = false;
        
        is_email_enabled = await this.checkNotificationEnableSettings(notification_id, customer_id).toPromise().then(result=>{
            let result_boolean = false;
            is_global_email_enabled = result['is_global_email_enabled'];
            is_customer_email_enabled = result['is_customer_email_enabled'];

            if(is_global_email_enabled == true && is_customer_email_enabled == true){result_boolean = true}
            else if(is_global_email_enabled == true && is_customer_email_enabled == false){result_boolean = false}
            else if(is_global_email_enabled == false && is_customer_email_enabled == true){result_boolean = false}
            else if(is_global_email_enabled == false && is_customer_email_enabled == false){result_boolean = false};
            return result_boolean;
            
        })
        
        return is_email_enabled;
    }

    checkAttachmentEnableSettings(attachment_id, customer_id): Observable<any> {
		return this.http.get<any>(this.url.rest  + '/tms/checkAttachmentEnableSettings/' + attachment_id + '/' + customer_id, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    async isSMSEnabledForDoc(attachment_id, customer_id){
        
        var is_global_sms_enabled = false;
        var is_customer_sms_enabled = false;
        var is_sms_enabled = false;
        
        is_sms_enabled = await this.checkAttachmentEnableSettings(attachment_id, customer_id).toPromise().then(result=>{
            let result_boolean = false;
            is_global_sms_enabled = result['is_global_sms_enabled'];
            is_customer_sms_enabled = result['is_customer_sms_enabled'];

            if(is_global_sms_enabled == true && is_customer_sms_enabled == true){result_boolean = true}
            else if(is_global_sms_enabled == true && is_customer_sms_enabled == false){result_boolean = false}
            else if(is_global_sms_enabled == false && is_customer_sms_enabled == true){result_boolean = false}
            else if(is_global_sms_enabled == false && is_customer_sms_enabled == false){result_boolean = false};
            return result_boolean;
        })

        return is_sms_enabled;

    }

    async isEmailEnabledForDoc(attachment_id, customer_id){

        var is_global_email_enabled = false;
        var is_customer_email_enabled = false;
        var is_email_enabled = false;
        
        is_email_enabled = await this.checkAttachmentEnableSettings(attachment_id, customer_id).toPromise().then(result=>{
            let result_boolean = false;
            is_global_email_enabled = result['is_global_email_enabled'];
            is_customer_email_enabled = result['is_customer_email_enabled'];

            if(is_global_email_enabled == true && is_customer_email_enabled == true){result_boolean = true}
            else if(is_global_email_enabled == true && is_customer_email_enabled == false){result_boolean = false}
            else if(is_global_email_enabled == false && is_customer_email_enabled == true){result_boolean = false}
            else if(is_global_email_enabled == false && is_customer_email_enabled == false){result_boolean = false};
            return result_boolean;
            
        })
        
        return is_email_enabled;
    }

    sendDocumentNotification(app, customer_id, filename, document_type_id, has_attachment): Observable<any> {
        var email_params = {app:app, customer_id:customer_id, filename: filename, document_type_id:document_type_id, has_attachment:has_attachment};
        
		return this.http.post<any>(this.url.rest  + '/tms/sendDocumentNotification', email_params, this.httpOptions)
            .pipe(
                catchError(this.handleError)
            );
    }

    // Error handling
    handleError(error) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            // Get client-side error
            errorMessage = error.error.message;
        } else {
            // Get server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        console.log(errorMessage);
        return throwError(errorMessage);
    }

}
